<template>
  <iframe
    id="template-item-html-frame"
    :title="item.id"
    :srcdoc="processedHtml"
    frameborder="0"
    width="100%"
  />
</template>

<script setup lang="ts">
import { HtmlItem } from "@/@types/flows/emailTemplates/items";
import { onMounted, computed } from "vue";
import { TemplateHtmlBuilder } from "@/app/flows/emailTemplates/utils/TemplateHtmlBuilder";

const props = defineProps<{ item: HtmlItem }>();

const processedHtml = computed(() => {
  const rawContent = props.item.content || "";
  if (!rawContent.trim()) return "";

  try {
    // 1. Extraer <style> tags del HTML original
    const styleTags = rawContent.match(/<style\b[^>]*>[\s\S]*?<\/style>/gi) || [];

    // 2. Inlinear CSS: mueve reglas de <style> a style="" en los elementos
    const bodyInlined = TemplateHtmlBuilder.inlineCssStyles(rawContent);

    // 3. Envolver en la MISMA estructura que generateHtmlTemplate
    return `<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    ${styleTags.join("\n    ")}
  </head>
  <body style="margin: 0; padding: 0; box-sizing: border-box; font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; width: 100% !important;">
    <table role="presentation" width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 100%;">
      <tr>
        <td align="center">
          <table role="presentation" width="100%" border="0" cellspacing="0" cellpadding="0" style="max-width: 700px; width: 100%; margin: 0 auto;">
            <tr>
              <td align="center">
                ${bodyInlined}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
  } catch (error) {
    console.error("Error processing preview HTML:", error);
    return rawContent;
  }
});

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const iframe = document.querySelector("#template-item-html-frame") as any;

  iframe.onload = function () {
    setTimeout(() => {
      const iframeDocument = iframe.contentWindow.document;
      const bodyStyle = window.getComputedStyle(iframeDocument.body);
      const marginTop = bodyStyle.marginTop.match(/\d+/g)?.map(Number).at(0) || 0;
      const marginBottom = bodyStyle.marginBottom.match(/\d+/g)?.map(Number).at(0) || 0;

      const height =
        iframeDocument.body.clientHeight < 150
          ? iframeDocument.body.clientHeight
          : iframeDocument.documentElement.scrollHeight;

      iframe.style.height = `${height + marginTop + marginBottom}px`;
    }, 0);
  };
});
</script>

<style scoped lang="sass">
// article
</style>
